// Run if in product page
if (location.pathname.indexOf('/products/') !== -1) {
  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector))
        }
  
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector))
                observer.disconnect()
            }
        })
  
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    })
  }

  // Rearrange product form elements created by a 3rd party app. Mutation Observer is required as the 3rd party app elements load after page load.
  waitForElm('#infiniteoptions-container').then((elm) => {
      document.querySelector('.t4s-product-form__buttons').before(document.querySelector('#infiniteoptions-container'));
  })

  // Add click event listener to make color variation click to scroll back to top
  if (window.innerWidth <= 768) {
      for (const swatch of document.querySelectorAll('.t4s-swatch__item')) {
        swatch.addEventListener('click', function() {
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        });
      }
  }

  // Event listener - Scroll to review on click of review tab
  document.querySelector('#b_db7330fa-7baa-4221-b4b9-73d07c966026').addEventListener('click', function() {
    $('.reputon-google-reviews-widget').parent()[0]?.scrollIntoView({behavior: 'smooth'});
  })
  
  // For mobile
  document.querySelector('#t44_db7330fa-7baa-4221-b4b9-73d07c966026').addEventListener('click', function() {
    $('.reputon-google-reviews-widget').parent()[0]?.scrollIntoView({behavior: 'smooth'});
  })
  
}

/* Barbie - Custom element color changes. */
if (location.pathname.indexOf('barbie') !== -1) {
  // Marquee Announcement Bar
  $(".homepage_marquee").css("background","#de1c85");
  $(".text_en a").css("color","white");
  $(".marquee-cta").css("color","#de1c85");
  

  // Footer
  $(".t4s-section-inner.t4s_nt_se_footer.t4s_se_footer.t4s-container-fluid").css("background","#de1c85");
  $("h3.t4s-col-heading.t4s-fnt-fm-1").css("color","white");
  $(".t4s-footer a, .t4s-footer-menu ul li a").css("color","white");

  // Navigation Header
  $(".t4s-site-nav__icons svg.t4s-icon").css("color","#de1c85");
  $(".t4s-nav__ul>li:nth-child(1)> a").css("color","#de1c85");
  $(".t4s-nav__ul>li:nth-child(2)> a").css("color","#de1c85");

}
